import { usePermissionsStore } from '#modules/auth/stores/permissions.store.js';
import { debugLog } from '@/shared/utils/debugLog.js';

/**
 * Permissions guard that checks if the user has required permissions to access a route
 *
 * Usage in routes:
 * {
 *   path: '/admin',
 *   meta: {
 *     permissions: [AppPermissions.ManageTeams]
 *   }
 * }
 *
 * @param {import('vue-router').RouteLocationNormalized} to - Target route
 * @param {import('vue-router').RouteLocationNormalized} _from - Source route
 */
export function permissionsGuard(to, _from) {
    const permissions = to.meta?.permissions;

    if (!permissions || !permissions.length) {
        debugLog('PermissionsGuard', 'No permissions required for route', { path: to.path });
        return;
    }

    const permissionsStore = usePermissionsStore();

    debugLog('PermissionsGuard', 'Checking permissions', {
        path: to.path,
        required: permissions,
    });

    if (!permissionsStore.hasAllPermissions(permissions)) {
        debugLog('PermissionsGuard', 'Permission check failed - redirecting to unauthorized', {
            required: permissions,
            userPermissions: permissionsStore.permissions,
        });

        return { name: 'unauthorized' };
    }

    debugLog('PermissionsGuard', 'Permission check passed');
}
